<template>
  <div class="create-box" :class="dyhState==1?'wid1':'wid2'">
    <div class="box-bg">
      <p>
        <span><img width="16" src="@/assets/icon/level.png" style="margin-right: 0.5rem" alt="">{{statusText}}订阅号</span>
      </p>
      <div class="boxContent">
        <div class="left">
          <div class="header"><div class="tit"></div><div class="txt">订阅号信息</div></div>
          <a-form-model :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :rules="rules">
            <a-form-model-item label="订阅号类型" prop="type">
              <a-select v-model="form.type" placeholder="请选择">
                <a-select-option v-for="(type,t) in subsTypeList" :key="t" :value="type.id">
                  {{type.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="订阅号名称" prop="name">
              <a-input v-model="form.name" />
            </a-form-model-item>
<!--            <a-form-model-item label="医院等级" prop="level">-->
<!--              <a-select v-model="form.level" placeholder="请选择">-->
<!--                <a-select-option v-for="(type,t) in typeIds" :key="t" :value="type.id">-->
<!--                  {{type.name}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-model-item>-->
<!--            <a-form-model-item label="医院类型" prop="hostype">-->
<!--              <a-select v-model="form.hostype" placeholder="请选择">-->
<!--                <a-select-option v-for="(type,t) in typeIds" :key="t" :value="type.id">-->
<!--                  {{type.name}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-model-item>-->
            <a-form-model-item label="logo" prop="logo">
              <!--              <a-upload name="avatar" list-type="picture-card" :show-upload-list="false"-->
              <!--                        :customRequest="uploaderShareCover">-->
              <!--                <a-button> <a-icon type="upload" /> 上传文件 </a-button>-->
              <!--              </a-upload>-->
              <a-upload
                  name="avatar"
                  list-type="picture-card"
                  :show-upload-list="false"
                  :customRequest="uploaderShareCover"
              >
                <img v-if="form.logo" :src="form.logo" alt="avatar" width="100%" />
                <a-button v-else> <a-icon type="upload" /> 上传文件 </a-button>
              </a-upload>
              <span style="font-size: 12px">限制格式为JPG、 PNG、GIF。建议尺寸: 1:1</span>
            </a-form-model-item>
            <a-form-model-item label="描述" prop="describe">
              <a-input type="textarea" v-model="form.describe" />
            </a-form-model-item>
<!--            <a-form-model-item label="启用" prop="isUse">-->
<!--              <a-switch v-model="form.isUse" style="margin-top: 10px" />-->
<!--            </a-form-model-item>-->
          </a-form-model>
        </div>
        <div class="mid"></div>
        <div class="right" >
          <div class="header"><div class="tit"></div><div class="txt">企业信息</div></div>
          <div class="bussiness">
            <p class="redstar">组织机构代码证/营业执照影印件</p>
            <a-upload
                name="avatar"
                :show-upload-list="false"
                :customRequest="uploaderShareCover2"
            >
              <img v-if="form.bussinessUrl" :src="form.bussinessUrl" alt=" " width="150px" />
              <a-button v-else style="margin: 5px 0"> <a-icon type="upload" /> 上传文件 </a-button>
            </a-upload>
            <p style="font-size: 12px">请上传彩色扫描件或复印件，要求图片信息清晰可见，必须加盖红色公章，最大5M</p>
          </div>
          <div class="header" style="margin-top: 2rem"><div class="tit"></div><div class="txt">管理员信息</div></div>
          <div class="idcard">
            <div class="front">
              <p class="redstar">身份证人像面</p>
              <div :class="form.frontUrl!=''?'imgbg2':'imgbg'">
                <a-upload
                    name="avatar"
                    :show-upload-list="false"
                    :customRequest="uploaderShareCover3"
                >
                  <img v-if="form.frontUrl" :src="form.frontUrl" width="100%" type="contain" alt=""/>
                  <a-icon class="plusicon" v-else type="plus"/>
                </a-upload>
              </div>
            </div>
            <div class="front">
              <p class="redstar">身份证国徽面</p>
              <div :class="form.backUrl!=''?'imgbg2':'imgbg'">

                <a-upload
                    name="avatar"
                    :show-upload-list="false"
                    :customRequest="uploaderShareCover4"
                >
                  <img v-if="form.backUrl" :src="form.backUrl"  width="100%" type="contain" alt=""/>
                  <a-icon class="plusicon" v-else type="plus"/>
                </a-upload>
              </div>
            </div>
          </div>
          <a-form-model style="width: 100%;margin-top: 1rem" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" :model="form"  :rules="rules3">
            <a-form-model-item label="姓名" prop="userName">
              <a-input v-model="form.userName" />
            </a-form-model-item>
            <a-form-model-item label="身份证号" prop="userIdNum">
              <a-input v-model="form.userIdNum" />
            </a-form-model-item>
            <a-form-model-item label="手机号" prop="phone">
              <a-input v-model="form.phone" disabled/>
            </a-form-model-item>
            <a-form-model-item label="验证码" prop="code" v-if="subsState=='create'">
              <a-input style="width: 50%" v-model="form.code" />
              <a-button style="
              background: #FF373C;
              border-radius: 2px;
              color: #fff;margin-left: 4%;width: 45%" @click="getAuthCode" v-if="firstCode">获取验证码</a-button>
              <a-button style="
              background: #FF373C;
              border-radius: 2px;
              color: #fff;margin-left: 4%;width: 45%;" :style="{opacity: disabled?'0.5':'1'}" @click="getAuthCode" v-else :disabled="disabled">
                <span v-show="expireTime<60&&expireTime>0">{{expireTime}}</span>
                重新获取
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>
    <footer>
      <div class="btn">
        <div class="cacel" @click="backToDetail">取消</div>
        <div class="save" @click="submitForm">提交审核</div>
      </div>
    </footer>
  </div>
</template>

<script>
import { createSubscribe, subscribeTypeList, sendSms, updateSubscribe } from "@/api/subscription";
import {fileUpload} from "@/api/content";
import {mapGetters} from "vuex";

export default {
  props:{
    typeIds:{
      type:Array
    },
    subsState:{
      type: String
    },
    editForm:{
      type: Object
    },
    subsId:{
      type: Number
    }
  } ,
  computed: {
    ...mapGetters(["dyhState"]),
  },
  data() {
    return {
      smsCode:'',
      firstCode:true,
      disabled:false,
      subsTypeList:[],
      labelCol: {span: 2},
      wrapperCol: {span: 6},
      form: {
        type: '',
        name: '',
        title: '',
        level:'',
        hostype:'',
        logo: '',
        describe: '',
        isUse: true,
        bussinessUrl:'',
        frontUrl:'',
        backUrl:'',
        userName:'',
        userIdNum:'',
        phone:'',
        code:'',
      },
      rules: {
        type: [
          {required: true, message: '请选择订阅号类型', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入订阅号名称', trigger: 'blur'},
        ],
        logo: [
          {required: true, message: '请上传订阅号logo', trigger: 'blur'},
        ],
        // title: [
        //   {required: true, message: '请输入副标题', trigger: 'blur'},
        // ],
        // level: [
        //   {required: true, message: '请选择医院等级', trigger: 'blur'},
        // ],
        // hostype: [
        //   {required: true, message: '请选择医院类型', trigger: 'blur'},
        // ],
      },
      rules3:{
        userName: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        userIdNum: [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
        ],

      },
      headers: {
        authorization: 'authorization-text',
      },
      expireTime:60,//倒计时
      statusText:'新增',
    }
  },
  watch:{
    editForm(val) {
      this.form=val
      console.log(val)
    },

  },
  created() {
    this.getSubsTypeList()
    this.form=this.editForm
    this.form.phone=JSON.parse(sessionStorage.getItem('userModel')).mobile
    if(this.subsState=='edit'){
      this.statusText='修改'
    }else{
      this.statusText='新增'
    }
  },
  methods:{
    // 取消创建
    backToDetail(){
      this.$emit('changeStatus','summary')
    },
    //提交审核
    async submitForm(){

      // console.log(this.form)
      if (!this.form.type) {
        this.$message.warning("请选择订阅号类型!");
        return false;
      }
      if (!this.form.name) {
        this.$message.warning("请输入订阅号名称!");
        return false;
      }
      if (!this.form.logo) {
        this.$message.warning("请上传订阅号logo!");
        return false;
      }
      if (!this.form.bussinessUrl) {
        this.$message.warning("请上传组织机构代码证明!");
        return false;
      }
      if (!this.form.frontUrl||!this.form.backUrl) {
        this.$message.warning("请上传身份证正反面照片!");
        return false;
      }
      if (!this.form.userName) {
        this.$message.warning("请输入姓名!");
        return false;
      }
      if (!this.form.userIdNum) {
        this.$message.warning("请输入身份证号!");
        return false;
      }
      if (!this.form.phone && this.subsState=='create') {
        this.$message.warning("请输入手机号!");
        return false;
      }
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if(reg.test(this.form.userIdNum) === false)
      {
        // alert("身份证输入不合法");
        this.$message.warning("身份证输入不合法!");
        return false;
      }
      if(this.subsState=='create'){
        this.newSubscribe()
      }else{
        this.changeSubscribe()
      }

    },
    //上传文件
    handleChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    async uploaderShareCover(option) {
      // console.log(this.dataInfo.shareCover);
      var form = new FormData();
      form.append("file ", option.file);
      let data = await fileUpload(form);
      this.form.logo = data.data.filedir;
    },
    async uploaderShareCover2(option) {
      // console.log(this.dataInfo.shareCover);
      var form = new FormData();
      form.append("file ", option.file);
      let data = await fileUpload(form);
      this.form.bussinessUrl = data.data.filedir;
    },
    async uploaderShareCover3(option) {
      // console.log(this.dataInfo.shareCover);
      var form = new FormData();
      form.append("file ", option.file);
      let data = await fileUpload(form);
      this.form.frontUrl = data.data.filedir;
    },
    async uploaderShareCover4(option) {
      // console.log(this.dataInfo.shareCover);
      var form = new FormData();
      form.append("file ", option.file);
      let data = await fileUpload(form);
      this.form.backUrl = data.data.filedir;
    },
    getAuthCode(){
      if(this.form.phone!=''){
        // this.firstCode=false
        this.showTimeOut()
        this.sendSmsCode()
      }else{
        this.$message.warning("请输入手机号!");
      }
    },
    //验证码倒计时
    showTimeOut(){
      let _this=this
      _this.disabled=true
      _this.firstCode=false
      // console.log(_this.expireTime)
      let timer = setInterval(()=>{
        if(_this.expireTime<0){
          clearInterval(timer)
          _this.disabled=false
          this.expireTime=60
        }else{
          _this.expireTime--
          // _this.showTimeOut()
        }
      },1000)
    },
    /** 接口*/
    //创建订阅号
    newSubscribe(){
      let that = this
      let form={
        adminExternalUid: JSON.parse(localStorage.getItem("userModel")).id,
        articleCount: 0,
        auditorMessage: "",
        auditorStatus: 0,
        auditorUid: 0,
        businessLicenseUrl: this.form.bussinessUrl,
        contactEmail: "",
        contactMobile: this.form.phone,
        contactName: this.form.userName,
        createAt: 0,
        createExternalUid: JSON.parse(localStorage.getItem("userModel")).id,
        createInternalUid: 0,
        desc: this.form.describe,
        id: 0,
        identityCardBackUrl: this.form.backUrl,
        identityCardFrontUrl: this.form.frontUrl,
        identityCardNumber: this.form.userIdNum,
        logoUrl: this.form.logo,
        name: this.form.name,
        sort: 0,
        status: 0,
        // status: this.form.isUse?1:0,
        subscribeId: 0,
        subtitle: this.form.title,
        tags:'',
        thumbUrl: "",
        typeId: this.form.type,
        updateAt: 0,
        codeKey:this.smsCode.data,
        codeValue:this.form.code
      }
      createSubscribe(form).then(res=>{
        if(res.status){
          this.$message.success('创建订阅号成功')
          setInterval(function (){
            that.$emit('changeStatus','summary')
          },500)
        }
      })
    },
    //修改订阅号
    changeSubscribe(){
      let that = this
      let subsid = parseInt(sessionStorage.getItem('subsId'))
      let form={
        // adminExternalUid: JSON.parse(localStorage.getItem("userModel")).id,
        // articleCount: 0,
        // auditorMessage: "",
        auditorStatus: 0,
        // auditorUid: 0,
        businessLicenseUrl: this.form.bussinessUrl,
        // contactEmail: "",
        contactMobile: this.form.phone,
        contactName: this.form.userName,
        // createAt: 0,
        // createExternalUid: JSON.parse(localStorage.getItem("userModel")).id,
        // createInternalUid: 0,
        desc: this.form.describe,
        id: subsid,
        identityCardBackUrl: this.form.backUrl,
        identityCardFrontUrl: this.form.frontUrl,
        identityCardNumber: this.form.userIdNum,
        logoUrl: this.form.logo,
        name: this.form.name,
        // sort: 0,
        status: 0,
        // status: this.form.isUse?1:0,
        // subscribeId: this.subsId,
        subtitle: this.form.title,
        // tags:'',
        // thumbUrl: "",
        typeId: this.form.type,
        // updateAt: 0,
        // codeKey:this.smsCode,
        // codeValue:this.form.code
      }
      updateSubscribe(form).then(res=>{
        if(res.status){
          this.$message.success('修改订阅号成功')
          sessionStorage.setItem('dyhState', 0)
          setInterval(function (){
            that.$emit('changeStatus','summary')
          },500)
        }
      })
    },
    getSubsTypeList(){
      let form={
        page:0,
        pageSize:20
      }
      subscribeTypeList(form).then(res=>{
        if(res.status){
          this.subsTypeList=res.data
        }
      })
    },
    sendSmsCode(){
      let form={
        mobile: this.form.phone,
      }
      sendSms(form).then(res=>{
        if(res.status){
          this.smsCode=res.data
        }
      })
    },
    //身份证号码验证
    async isCardNo(card) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if(reg.test(card) === false)
      {
        // alert("身份证输入不合法");
        this.$message.warning("身份证输入不合法!");
        return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>